import APIService from 'services/APIService'

const api = APIService()

export const getNewRemedials = bpId =>
  api.get(`/building-passport/${bpId}/remedials/new-summary`)
